import { FC, useState } from "react";
import { TileSize } from "../constants";
import { HudInterface } from "../hud";
import { DynamicResources } from "../types";
import { TileOverlayDisplay } from "./TileOverlayDisplay";

export interface AllTileOverlaysProps {
  hudInterface: HudInterface | null;
}

interface TileOverlayData {
  x: number;
  y: number;
  resources: DynamicResources;
  label: string;
}

export const AllTileOverlays: FC<AllTileOverlaysProps> = ({ hudInterface }) => {
  const [refreshKey] = useState(0);

  if (!hudInterface) return null;

  // Get all tile data for 5x7 playable area (excluding 1-tile border)
  const tileData: TileOverlayData[] = [];
  console.log("c", hudInterface.cols);
  for (let x = 1; x <= hudInterface.cols; x++) {
    for (let y = 1; y <= hudInterface.rows; y++) {
      const resourceData = hudInterface.getResourcesAtTile(x, y);
      if (resourceData) {
        // Show all tiles that have data, regardless of resources
        tileData.push({
          x,
          y,
          resources: resourceData.total,
          label: resourceData.label,
        });
      }
    }
  }

  return (
    <div
      className="relative pointer-events-none"
      data-testid="all-overlays"
      key={refreshKey}
    >
      {tileData.map((tile) => (
        <TileOverlayDisplay
          key={`${tile.x}-${tile.y}`}
          x={tile.x}
          y={tile.y}
          screenX={tile.x * TileSize * 2}
          screenY={tile.y * TileSize * 2}
          resources={tile.resources}
          label={tile.label}
          width="64px"
          height="64px"
        />
      ))}
    </div>
  );
};
